<template>
  <div class="error">
    <img class="source" :src="defaultSrc" alt="" />
    <div class="res">识别失败，未发现任何配料</div>
    <div class="tips">可能的原因有：图片不是配料表或图片模糊、变形、颠倒</div>
    <img
      class="notice"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_err_text"
      alt=""
    />
    <div class="btn" @click="bindClick">
      <span>重新拍摄</span>
      <input
        v-if="!isApp"
        class="image-input"
        type="file"
        ref="files"
        capture="camera"
        accept="image/*"
        @change="bindPicChange"
        name=""
        id=""
      />
    </div>
    <div class="connect-coach" @click="bindConnect" v-if="userStatus == 0">
      <span class="chat iconfont icon-comments-fill-8"></span
      ><span class="text">加入减脂食品研究所，为你免费解读</span
      ><span class="right iconfont icon-you"></span>
    </div>
    <!--   <div class="btn-tips">请拍摄如上图正确、清晰的配料表图片哦</div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      isApp: false,
      userStatus: 1,
      defaultSrc:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_err_icon_2'
    }
  },
  computed: {},
  created() {
    this.isApp = this.$http._isApp()
    this.getUserStatus()
    //埋点 配料表识别失败
    this.$buryPoint('APP_INGREDIENT_USE_FAIL', {})
  },
  methods: {
    getUserStatus() {
      this.$http
        .getBaseApp('tool/Ingredient/judgeUserIdentity', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.userStatus = res.data.code
          }
        })
        .catch(() => {})
    },
    async bindClick() {
      if (this.isApp) {
        let res = await this.$betterwe.onAppCamera().catch(() => {})
        if (res) {
          res = JSON.parse(res)
          if (!Array.isArray(res)) {
            this.$toast('获取图片失败')
          }
          this.$store.commit(
            'ingredient/setImageSource',
            'data:image/png;base64,' + res[0]
          )
          this.$router.replace('/ingredient/preview')
        }
      }
      //埋点 配料表去使用
      this.$buryPoint('APP_INGREDIENT_USE', {})
    },
    bindConnect() {
      if (this.$http._isApp()) {
        this.$betterwe.onAppPageUrlRoute(
          `/miniProgram?userName=gh_0d804ee2c21b&path=pages/image-page/index?url=https%3A%2F%2Fcdnvue.gymcity.com.cn%2Fbetterwe_1.0%2Fvue%2F3ee79235755ee3f24794be241c8e89a5.jpg`
        )
      }
    },
    bindPicChange(e) {
      let file = e.target.files[0] //图片文件名
      /*  lrz(file,{width:1200,quality:0.5})
        .then((rst)=> {
            // 处理成功会执行
            console.log(rst);
            this.localUrl = rst.base64;
            this.isPreview =true;
        })
        .catch(function (err) {
            alert("压缩失败");
            // 处理失败会执行
        })
        .always(function () {
            // 不管是成功失败，都会执行
        });
        return; */
      if (!e || !window.FileReader) {
        // 看是否支持FileReader
        this.$toast('暂不支持查看')
        return
      }
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '加载图片中...'
      })
      let reader = new FileReader()
      reader.readAsDataURL(file) // 关键一步，在这里转换的
      reader.onload = (e) => {
        this.$toast.clear()
        this.$store.commit('ingredient/setImageSource', e.target.result)
        this.$router.replace('/ingredient/preview')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.error {
  text-align: center;
  .source {
    width: 132px;
    height: 132px;
    margin: 30px auto -10px;
    object-fit: contain;
  }
  .res {
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 25px;
    margin-bottom: 2px;
  }
  .tips {
    width: 230px;
    margin: 0 auto;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.5);
    line-height: 17px;
    margin-bottom: 30px;
  }
  .notice {
    margin: 0 auto;
    width: 315px;
    height: 180px;
    background: #ffffff;
    border-radius: 12px;
    object-fit: contain;
    margin-bottom: 30px;
  }
  .btn {
    position: relative;
    margin: 0 auto;
    width: 315px;
    height: 44px;
    border-radius: 12px;
    background: #6236ff;
    border-radius: 12px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 44px;
    margin-bottom: 24px;
    .image-input {
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
      width: 100%;
      height: 100%;
    }
  }
  .btn-tips {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.5);
    line-height: 17px;
  }
  .connect-coach {
    display: inline-flex;
    margin: 0 auto;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #6236ff;
    .chat {
      color: rgba(98, 54, 255, 1);
      margin-right: 6px;
    }
    .text {
      line-height: 20px;
    }
    .right {
      margin-left: 3px;
      color: rgba(98, 54, 255, 1);
    }
  }
}
</style>
